import { IDashboardExecuteInput } from '../../../../../../utils/apollo/graphqlSchema';
import { IDraftDashboardCustomization } from '../../../../../../redux/slices/dashboards/dashboardInstance';
import { parseFilterToInput } from '../../../../../../utils/filterFields';
import { toDatePickerInput } from '../../../../../../components/Builder/utils/builderUtils';
import { MaybeNil } from '../../../../../../utils/interfaces';
import { assertNotNil } from '../../../../../../utils/types';

interface IArguments {
  draftCustomization: IDraftDashboardCustomization;
  schemaId: MaybeNil<string>;
  instanceId: string;
}

const prepareDashboardExecuteInput = ({
  draftCustomization,
  schemaId,
  instanceId,
}: IArguments): IDashboardExecuteInput => {
  const result: IDashboardExecuteInput = {
    filter: {
      schemaId: schemaId ?? null,
      // will be populated below if there is one
      filter: null,
      // will be populated below if there is one
      datePicker: null,
    },
    instanceId,
  };

  if (draftCustomization.filter?.conditions?.length) {
    assertNotNil(schemaId);
    result.filter.filter = parseFilterToInput(
      draftCustomization.filter,
      schemaId,
    );
  }

  if (draftCustomization.datePicker) {
    result.filter.datePicker = toDatePickerInput(draftCustomization.datePicker);
  }

  return result;
};

export default prepareDashboardExecuteInput;
